import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../../services/auth';

const RequireAuth = ({ children, roles = [] }) => {
  const location = useLocation();
  const user = getCurrentUser();

  // Not authenticated: send to login and remember where we came from.
  if (!user) {
    const targetPath = `${location.pathname}${location.search}${location.hash}`;
    localStorage.setItem('postLoginRedirect', targetPath);
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Authenticated but not authorized for this route.
  if (roles.length > 0 && !roles.includes(user.role)) {
    const fallback = user.role === 'admin' ? '/admin/dashboard' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default RequireAuth;
